import { DownloadAppCtaLayout } from '@/features/downloadAppCta/DownloadAppCtaLayout';
import { HomeLayout } from '@/layout/homeLayout/HomeLayout';

export default function Home() {
  /* The home stays server-rendered (hydration) until the CTA is known to be eligible. */
  return <DownloadAppCtaLayout homeLayout={<HomeLayout />} />;
}
